import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {ModalContainer} from '../../../../../components/Wizard/Wizard';
import {
  STORAGE_MNG_LKFS_CHANNEL_SETS_SAVE_DATA,
  loadMediaInfo,
  getClientAudioChannelSettings
} from '../../../actions';
import {Button, Modal} from "react-bootstrap";

const FileStepContentStyled = styled.div`
  padding: 0;

  .file-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
  }

  .media-info-section {
    margin-bottom: 15px;
    padding: 10px;
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 4px;

    h4 {
      margin: 0 0 15px 0;
      color: #495057;
      font-size: 16px;
    }

    .loading-state {
      color: #6c757d;
      font-style: italic;
    }

    .channels-capacity {
      margin-bottom: 10px;
      padding: 10px;
      background-color: #e3f2fd;
      border-radius: 4px;

      strong {
        color: #1976d2;
        font-size: 14px;
        display: block;
        margin-bottom: 5px;
      }

      .capacity-match {
        color: #28a745;
        font-size: 12px;
        font-weight: 600;
      }

      .capacity-mismatch {
        color: #dc3545;
        font-size: 12px;
        font-weight: 600;
      }
    }

    .channel-sets-buttons {
      margin-bottom: 15px;

      h5 {
        margin: 0 0 10px 0;
        color: #495057;
        font-size: 14px;
        font-weight: 600;
      }

      .channel-set-btn {
        display: inline-block;
        margin: 0 10px 10px 0;
        padding: 8px 16px;
        background-color: #007bff;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 13px;
        transition: background-color 0.2s;

        &:hover:not(.disabled) {
          background-color: #0056b3;
        }

        &.disabled {
          background-color: #6c757d;
          cursor: not-allowed;
          opacity: 0.6;
        }
      }
    }

    .channel-sets-panel {
      h5 {
        margin: 0 0 10px 0;
        color: #495057;
        font-size: 14px;
        font-weight: 600;
      }

      .empty-panel {
        padding: 15px;
        text-align: center;
        color: #6c757d;
        font-style: italic;
        background-color: #f8f9fa;
        border: 2px dashed #dee2e6;
        border-radius: 4px;
      }

      .channel-sets-list {
        .channel-set-tag {
          display: inline-flex;
          align-items: center;
          margin: 0 8px 8px 0;
          padding: 6px 12px;
          background-color: #28a745;
          color: white;
          border-radius: 4px;
          font-size: 13px;
          transition: background-color 0.2s, opacity 0.2s;

          &.disabled {
            background-color: #6c757d;
            opacity: 0.7;
          }

          .channel-set-checkbox {
            margin: 0 8px 0 0;
            width: 14px;
            height: 14px;
            cursor: pointer;
          }

          .channel-set-name {
            margin-right: 8px;
          }

          .remove-btn {
            background: none;
            border: none;
            color: #dc3545;
            cursor: pointer;
            font-size: 16px;
            line-height: 1;
            padding: 0;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              background-color: rgba(255, 255, 255, 0.3);
            }
          }
        }
      }
    }
  }

  .form-group {
    margin-bottom: 15px;
  }

  .form-label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
    color: #555;
  }

  .form-control {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
  }

  .checkbox-group {
    display: flex;
    align-items: center;
    margin-top: 5px;

    label {
      margin: 0;
    }
  }

  .checkbox-group input[type="checkbox"] {
    margin: 0 8px 0 0;
  }

  .step-counter {
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
  }
`;

class FileStepComponent extends Component {

  handleSkipChange = (e) => {
    const { updateFileData } = this.props;
    const currentData = this.props.fileData || {};
    updateFileData({
      ...currentData,
      skip: e.target.checked
    });
  };

  handleAddChannelSet = (channelSet) => {
    const { file, updateFileData, fileData, getChannelsFromMediaInfo } = this.props;
    const currentData = fileData || {};
    const currentChannelSets = currentData.channelSets || [];
    const totalChannels = getChannelsFromMediaInfo(file);

    // Calculate current used channels
    const usedChannels = currentChannelSets.reduce((sum, set) => sum + set.capacity, 0);

    // Check if adding this channel set would exceed capacity
    if (usedChannels + channelSet.capacity <= totalChannels) {
      const newChannelSets = [...currentChannelSets, { ...channelSet, id: Date.now(), allowEditEnable: channelSet.enabled }];
      updateFileData({
        ...currentData,
        channelSets: newChannelSets
      });
    }
  };

  handleRemoveChannelSet = (channelSetId) => {
    const { updateFileData, fileData } = this.props;
    const currentData = fileData || {};
    const currentChannelSets = currentData.channelSets || [];

    const newChannelSets = currentChannelSets.filter(set => set.id !== channelSetId);
    updateFileData({
      ...currentData,
      channelSets: newChannelSets
    });
  };

  handleToggleChannelSet = (channelSetId) => {
    const { updateFileData, fileData } = this.props;
    const currentData = fileData || {};
    const currentChannelSets = currentData.channelSets || [];

    const newChannelSets = currentChannelSets.map(set =>
      set.id === channelSetId
        ? { ...set, enabled: !set.enabled }
        : set
    );

    updateFileData({
      ...currentData,
      channelSets: newChannelSets
    });
  };

  renderChannelSetsInterface = () => {
    const { file, fileData, isLoadingMediaInfo, getChannelsFromMediaInfo, getMultiChannelStreamsCounter, isLoadingClientAudioSettings, getClientAudioSettings } = this.props;
    const currentData = fileData || {};

    if (isLoadingMediaInfo) {
      return (
        <div className="media-info-section">
          <h4>Channel Sets Configuration</h4>
          <div className="loading-state">Loading media information...</div>
        </div>
      );
    }

    const multiChannelStreamsCounter = getMultiChannelStreamsCounter(file);
    if (multiChannelStreamsCounter > 0) {
      return (
          <div className="media-info-section">
            <h4>Channel Sets</h4>
            <div>No settings are required, the file contains multi-channel audio streams</div>
          </div>
      );
    }

    const skipFileElement = (
        <div className="checkbox-group">
          <input
              type="checkbox"
              id={`skip-${file && file.key ? file.key : 'unknown'}`}
              checked={currentData.skip || false}
              onChange={this.handleSkipChange}
          />
          <label htmlFor={`skip-${file && file.key ? file.key : 'unknown'}`}>
            Skip this file - so the [default] client audio settings will be used
          </label>
        </div>
    );

    const totalChannels = getChannelsFromMediaInfo(file);

    if (totalChannels === 0) {
      return (
        <>
          <div className="media-info-section">
            <h4>Channel Sets</h4>
            <div className="loading-state">No audio track found or media info not available</div>
          </div>
          {skipFileElement}
        </>
      );
    }

    const currentChannelSets = currentData.channelSets || [];
    const usedChannels = currentChannelSets.reduce((sum, set) => sum + set.capacity, 0);

    // Get client audio settings
    const clientAudioSettings = getClientAudioSettings(file);

    let channelSetOptions = [];
    if (clientAudioSettings && clientAudioSettings.data.lkfsAudioChannelSets) {
      channelSetOptions = clientAudioSettings.data.lkfsAudioChannelSets.map(set => {
        const channelSetsArray = JSON.parse(set.channelSetValue);

        return {
          name: set.channelSetName,
          capacity: channelSetsArray.length,
          channels: set.channelSetValue,
          enabled: set.enableLkfs
        }
      });
    }

    return (
      <>
      <div className="media-info-section">
        <h4>Channel Sets Configuration</h4>

        {isLoadingClientAudioSettings && (
          <div className="loading-state">Loading client audio channel settings...</div>
        )}

        <div className="channel-sets-buttons">
          <h5>Available Channel Sets:</h5>
          {channelSetOptions.map((option, index) => {
            const canAdd = usedChannels + option.capacity <= totalChannels;
            return (
              <button
                key={index}
                className={`channel-set-btn ${!canAdd ? 'disabled' : ''}`}
                onClick={() => canAdd && this.handleAddChannelSet(option)}
                disabled={!canAdd}
              >
                {option.name} ({option.capacity} ch)
              </button>
            );
          })}
        </div>

        <div className="channel-sets-panel">
          <h5>Selected Channel Sets:</h5>
          {currentChannelSets.length === 0 ? (
            <div className="empty-panel">No channel sets selected</div>
          ) : (
            <div className="channel-sets-list">
              {currentChannelSets.map((set) => (
                <div key={set.id} className={`channel-set-tag ${set.enabled === false ? 'disabled' : ''}`}>
                  <input
                    type="checkbox"
                    checked={set.enabled !== false}
                    disabled={set.allowEditEnable === false}
                    onChange={() => this.handleToggleChannelSet(set.id)}
                    className="channel-set-checkbox"
                  />
                  <span className="channel-set-name">{set.name}</span>
                  <button
                    className="remove-btn"
                    onClick={() => this.handleRemoveChannelSet(set.id)}
                    title="Remove channel set"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="channels-capacity">
          <strong>Audio Channels: {usedChannels} / {totalChannels} used</strong>
          {usedChannels === totalChannels && (
            <div className="capacity-match">✓ All channels configured</div>
          )}
          {usedChannels > 0 && usedChannels !== totalChannels && (
            <div className="capacity-mismatch">⚠ Must use all {totalChannels} channels</div>
          )}
        </div>
        <div style={{ marginTop: '10px', fontSize: '12px', color: '#6c757d' }}>
          Client audio settings: {(clientAudioSettings && clientAudioSettings.data.clientAudioChannelSets) || 'Not found client audio settings'}
        </div>
      </div>
      {skipFileElement}
      </>
    );
  };

  render() {
    const { file } = this.props;
    const fileName = (file && file.name) || (file && file.key) || 'Unknown File';

    return (
      <FileStepContentStyled>
        <div className="file-name">
          File: {fileName}
        </div>

        {this.renderChannelSetsInterface()}
      </FileStepContentStyled>
    );
  }
}

class AudioChannelsStep extends Component {
  state = {
    currentFileIndex: 0,
    mediaInfoCache: {}, // Cache for media info by file key
    loadingMediaInfo: {}, // Track loading state for each file
    clientAudioSettingsCache: {}, // Cache for client audio channel settings by file key
    loadingClientAudioSettings: {} // Track loading state for client audio settings
  };

  updateFileData = (data) => {
    const { files } = this.props;
    const file = files[this.state.currentFileIndex];

    this.props.onSaveData(file, data);
  };

  // Load media info for a specific file
  loadMediaInfoForFile = (file) => {
    if (!file || !file.fsRootID || !file.contentID) {
      return;
    }

    const fileKey = file.key;

    // Check if already cached
    if (this.state.mediaInfoCache[fileKey]) {
      return;
    }

    // Check if already loading
    if (this.state.loadingMediaInfo[fileKey]) {
      return;
    }

    // Set loading state
    this.setState(prevState => ({
      loadingMediaInfo: {
        ...prevState.loadingMediaInfo,
        [fileKey]: true
      }
    }));

    // Load media info using the action
    this.props.loadMediaInfo(file).then((response) => {
      // Cache the response
      this.setState(prevState => ({
        mediaInfoCache: {
          ...prevState.mediaInfoCache,
          [fileKey]: response
        },
        loadingMediaInfo: {
          ...prevState.loadingMediaInfo,
          [fileKey]: false
        }
      }));

      // After media info is loaded, load client audio channel settings
      this.loadClientAudioSettingsForFile(this.props.WOMemfis, file);
    }).catch(() => {
      // Handle error
      this.setState(prevState => ({
        loadingMediaInfo: {
          ...prevState.loadingMediaInfo,
          [fileKey]: false
        }
      }));
    });
  };

  // Parse channel sets string and apply to file data
  parseAndApplyClientChannelSets = (file, channelSetsString, lkfsAudioChannelSets) => {
    try {
      // Only apply if no existing data in audioChannelSetsData for this file
      const currentData = this.props.audioChannelSetsData.find(item => item.file.contentID === file.contentID);
      if (currentData && currentData.data) {
        // File already has channel sets data, don't overwrite
        return;
      }

      // Parse the JSON string: "[[\"L\",\"R\"],[\"L\",\"R\"],[\"L\",\"R\"]]"
      const channelSetsArray = JSON.parse(channelSetsString);

      if (!Array.isArray(channelSetsArray)) {
        console.warn('Channel sets is not an array:', channelSetsArray);
        return;
      }

      // Convert to our channel set format
      const parsedChannelSets = channelSetsArray.map((channels, index) => {
        if (!Array.isArray(channels)) {
          console.warn('Invalid channel set format:', channels);
          return null;
        }

        // Create channels string in our format
        const channelsString = JSON.stringify(channels);

        // Try to match with known channel set options
        const knownChannelSet = lkfsAudioChannelSets.find(option => option.channelSetValue === channelsString);

        let name;
        if (knownChannelSet) {
          name = knownChannelSet.channelSetName;
        } else {
          // Create a name based on channels
          name = `${channels.join(', ')}`;
        }

        return {
          id: Date.now() + index, // Unique ID
          name: name,
          capacity: channels.length,
          channels: channelsString,
          enabled: true // Default to enabled
        };
      }).filter(set => set !== null); // Remove any invalid sets

      // Update file data with parsed channel sets
      if (parsedChannelSets.length > 0) {
        this.updateFileData({
          //...currentData.data,
          channelSets: parsedChannelSets
        });
      }
    } catch (error) {
      console.error('Error parsing channel sets:', error, 'Input:', channelSetsString);
    }
  };

  // Load client audio channel settings for a specific file
  loadClientAudioSettingsForFile = (woMemfis, file) => {
    const fileKey = file.key;

    // Load client audio channel settings using the action
    this.props.getClientAudioChannelSettings(woMemfis, file.key).then((response) => {
      // Cache the response
      this.setState(prevState => ({
        clientAudioSettingsCache: {
          ...prevState.clientAudioSettingsCache,
          [fileKey]: response
        },
        loadingClientAudioSettings: {
          ...prevState.loadingClientAudioSettings,
          [fileKey]: false
        }
      }));

      // Parse and apply channel sets from client settings
      if (response && response.data && response.data.clientAudioChannelSets) {
        this.parseAndApplyClientChannelSets(file, response.data.clientAudioChannelSets, response.data.lkfsAudioChannelSets);
      }
    }).catch(() => {
      // Handle error
      this.setState(prevState => ({
        loadingClientAudioSettings: {
          ...prevState.loadingClientAudioSettings,
          [fileKey]: false
        }
      }));
    });
  };

  // Get channels from cached media info for a specific file
  getChannelsFromMediaInfo = (file) => {
    if (!file) {
      return 0;
    }

    const fileKey = file.key;
    const mediaInfo = this.state.mediaInfoCache[fileKey];

    if (!mediaInfo || !mediaInfo.MediaInfo) {
      return 0;
    }

    const media = mediaInfo.MediaInfo.media;
    const mediaKeys = Object.keys(media);

    let audioTrackCount = 0;

    for (const key of mediaKeys) {
      const trackObj = media[key];
      if (trackObj.type === 'Audio') {
        // audio tracks can contain multiple audio channels
        audioTrackCount = audioTrackCount + (parseInt(trackObj['Channels']) || 0);
      }
    }

    return audioTrackCount;
  };

  // Get channels from cached media info for a specific file
  getMultiChannelStreamsCounter = (file) => {
    if (!file) {
      return 0;
    }

    const fileKey = file.key;
    const mediaInfo = this.state.mediaInfoCache[fileKey];

    if (!mediaInfo || !mediaInfo.MediaInfo) {
      return 0;
    }

    const media = mediaInfo.MediaInfo.media;
    const mediaKeys = Object.keys(media);

    let multiChannelStreamsCounter = 0;

    for (const key of mediaKeys) {
      const trackObj = media[key];
      if (trackObj.type === 'Audio') {
        const channels = parseInt(trackObj['Channels']) || 0;
        if (channels > 1) {
          multiChannelStreamsCounter++;
        }
      }
    }

    return multiChannelStreamsCounter;
  };

  // Check if media info is loading for a file
  isMediaInfoLoading = (file) => {
    if (!file) {
      return false;
    }
    return this.state.loadingMediaInfo[file.key] || false;
  };

  // Check if client audio settings is loading for a file
  isClientAudioSettingsLoading = (file) => {
    if (!file) {
      return false;
    }
    return this.state.loadingClientAudioSettings[file.key] || false;
  };

  // Get client audio settings from cache for a specific file
  getClientAudioSettings = (file) => {
    if (!file) {
      return null;
    }
    return this.state.clientAudioSettingsCache[file.key] || null;
  };

  componentWillMount() {
    this.loadMediaInfoForFile(this.props.files[0]);
  }

  componentDidUpdate(prevProps, prevState) {
    // Load media info when step changes
    const { files } = this.props;
    const { currentFileIndex } = this.state;
    if (prevState.currentFileIndex !== currentFileIndex && files && files[currentFileIndex]) {
      this.loadMediaInfoForFile(files[currentFileIndex]);
    }

    // Load media info for first file when modal opens
    if (prevState.currentFileIndex === 0 && this.state.currentFileIndex === 0 && files && files.length > 0) {
      //this.loadMediaInfoForFile(files[0]);
    }
  }

  isValidFileSettings = () => {
    const { files, audioChannelSetsData } = this.props;
    const { currentFileIndex } = this.state;
    const file = files[currentFileIndex];
    const fileItem = audioChannelSetsData.find(item => item.file.contentID === file.contentID) || {};
    const fileData = fileItem.data || {};
    const isSkipped = fileData.skip;

    // no required to configure channel sets when file contains multi channel audio streams (tracks)
    const multiChannelStreamsCounter = this.getMultiChannelStreamsCounter(file);
    if (multiChannelStreamsCounter > 0) {
      return true;
    }

    // Check if channel sets capacity equals total channels from mediainfo
    let channelSetsMatchCapacity = false;
    if (fileData.channelSets && fileData.channelSets.length > 0) {
      const totalChannelsFromMedia = this.getChannelsFromMediaInfo(file);
      const usedChannels = fileData.channelSets.reduce((sum, set) => sum + set.capacity, 0);

      channelSetsMatchCapacity = usedChannels === totalChannelsFromMedia;
    }

    return isSkipped || channelSetsMatchCapacity;
  }

  renderBody = () => {
    const {currentFileIndex} = this.state;
    const {files, audioChannelSetsData} = this.props;

    const currentFile = files[currentFileIndex];
    const currentFileItem = (currentFile && audioChannelSetsData.find(item => item.file.contentID === currentFile.contentID)) || {};
    const currentFileData = currentFileItem.data || {};

    return (
      <FileStepComponent
        file={currentFile}
        fileData={currentFileData}
        updateFileData={this.updateFileData}
        isLoadingMediaInfo={this.isMediaInfoLoading(currentFile)}
        getChannelsFromMediaInfo={this.getChannelsFromMediaInfo}
        getMultiChannelStreamsCounter={this.getMultiChannelStreamsCounter}
        isLoadingClientAudioSettings={this.isClientAudioSettingsLoading(currentFile)}
        getClientAudioSettings={this.getClientAudioSettings}
      />
    );
  }

  renderButtons = () => {
    const {files} = this.props;
    const {currentFileIndex} = this.state;
    const isLastFile = (currentFileIndex + 1) === files.length;
    const isFirstFile = currentFileIndex === 0;

    const backButton = (
      <Button
        bsStyle="default"
        onClick={() => isFirstFile ? this.props.onBack() : this.setState({currentFileIndex: currentFileIndex - 1})}
      >
        Back
      </Button>
    );

    const isValid = this.isValidFileSettings();
    if (isLastFile) {
      return (
        <>
          {backButton}
          <Button
            bsStyle="primary"
            disabled={!isValid}
            onClick={this.props.onContinue}
          >
            Submit
          </Button>
        </>
      )
    }

    return (
      <>
        {backButton}
        <Button
          bsStyle="primary"
          disabled={!isValid}
          onClick={() => this.setState({currentFileIndex: currentFileIndex + 1})}
        >
          Continue
        </Button>
      </>
    );
  }

  render() {
    return (
      <>
        <Modal.Body>
          <ModalContainer className="container-fluid">
            {this.renderBody()}
          </ModalContainer>
        </Modal.Body>
        <Modal.Footer>
          {this.renderButtons()}
          <Button
            bsStyle="default"
            onClick={this.props.onCancel}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </>
    );
  }
}

export default connect(
  function mapState(state, ownProps) {
    const { audioChannelSetsData, currentWOMemfis } = state.storageManager.LKFSModalState;

    return {
      files: ownProps.files || state.storageManager.checkedItems || [],
      audioChannelSetsData,
      WOMemfis: ownProps.WOMemfis || currentWOMemfis
    };
  },
  function mapDispatch(dispatch) {
    return {
      onSaveData: (file, data) => dispatch({
        type: STORAGE_MNG_LKFS_CHANNEL_SETS_SAVE_DATA,
        file,
        data
      }),
      loadMediaInfo: (file) => dispatch(loadMediaInfo(file)),
      getClientAudioChannelSettings: (woMemfis, fileName) => dispatch(getClientAudioChannelSettings(woMemfis, fileName))
    };
  }
)(AudioChannelsStep);
